<div class="col-12 col-md-6 w-100 w-md-auto mb-3 container mt-md-0 mt-3">
  <div class="card shadow-sm">
    <div class="card-header bg-light d-flex justify-content-between align-items-center">
      <h6 class="m-0 d-flex align-items-center">
        <i class="pi pi-user me-2 text-danger"></i> Profile
      </h6>
      <a class="btn " role="button" (click)="openDialog()">
        <i class="pi pi-pen-to-square me-1 text-danger"></i> Edit
      </a>
    </div>
    <div class="card-body">
      <!-- Full Name -->
      <div class="row d-flex align-items-center mb-2">
        <div class="col-4 col-sm-3 fw-bold">Full Name</div>
        <div class="col-8 col-sm-9 text-secondary">{{ customer.firstName }} {{ customer.lastName }}</div>
      </div>
      <hr class="my-2">

      <!-- Email -->
      <div class="row d-flex align-items-center mb-2">
        <div class="col-4 col-sm-3 fw-bold">Email</div>
        <div class="col-8 col-sm-9 text-secondary">{{ customer.emailId }}</div>
      </div>
      <hr class="my-2">

      <!-- Gender -->
      <div class="row d-flex align-items-center mb-2">
        <div class="col-4 col-sm-3 fw-bold">Gender</div>
        <div class="col-8 col-sm-9 text-secondary">{{ customer.gender }}</div>
      </div>
      <hr class="my-2">

      <!-- Phone -->
      <div class="row d-flex align-items-center mb-2">
        <div class="col-4 col-sm-3 fw-bold">Phone</div>
        <div class="col-8 col-sm-9 text-secondary">{{ customer.mobileNumber }}</div>
      </div>
      <hr class="my-2">

      <!-- Address -->
      <div class="row d-flex align-items-center mb-2">
        <div class="col-4 col-sm-3 fw-bold">Address</div>
        <div class="col-8 col-sm-9 text-secondary">{{ addresses.length ? addresses[0].fullAddress : '' }}</div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Edit Your Profile" [modal]="true" [(visible)]="visible" [style]="{ width: '40rem' }">
  <div class="container p-3" style="max-width: 600px;">
    <form *ngIf="editModal" class="text-black">
      <div class="mb-4">
        <label for="name" class="form-label fw-bold fs-6">Full Name</label>
        <input id="name" class="form-control fs-6" required name="name" [readOnly]="isNameFilled()" value="{{ customer.firstName }} {{ customer.lastName }}" placeholder="Full Name"/>
      </div>
      <div class="mb-4">
        <label for="email" class="form-label fw-bold fs-6">Email</label>
        <input id="email" class="form-control fs-6" required name="email" [(ngModel)]="customer.emailId" placeholder="Email"/>
      </div>
      <div class="mb-4">
        <label for="gender" class="form-label fw-bold fs-6">Gender</label>
        <select id="gender" class="form-select fs-6" name="Gender" [(ngModel)]="customer.gender">
          <option value="" disabled>Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>
      </div>
      <div class="mb-4">
        <label for="dob" class="form-label fw-bold fs-6">Date of Birth</label>
        <input id="dob" type="date" class="form-control fs-6" name="dob" [(ngModel)]="customer.dob"/>
      </div>
      <div class="d-flex justify-content-center mt-4">
        <button class="btn btn-danger px-4 py-2 fs-6 fw-bold" (click)="submitForm()">
          Update
        </button>
      </div>
    </form>
  </div>
</p-dialog>
